export const NAME = 'references';
export const LEVEL_ONE = 'ReferencesComponentReducer';
